import { takeLatest, put, call } from 'redux-saga/effects';
import * as UserActions from './actions';
import * as UserService from '../../../api/UserService';
import i18n from '../../../i18n/i18n';
import type { Effect } from 'redux-saga/effects';

export function* handleFetchUser(): Generator<Effect, void, any> {
  try {
    const response = yield call(UserService.getUser);
    const {
      data: { user: noshUser },
    } = response;
    yield put(UserActions.fetchUserSuccess(noshUser));
  } catch (err) {
    const error = err as any;
    const message = error?.response?.data?.error?.message;
    yield put(
      UserActions.fetchUserFail(
        message?.[i18n.getLang()] || 'Error occurred fetching user',
      ),
    );
  }
}

export function* watchFetchUser() {
  yield takeLatest(UserActions.FETCH_USER, handleFetchUser);
}

export function* handleFetchPaymentInfo(): Generator<Effect, void, any> {
  try {
    const response = yield call(UserService.getPaymentInfo);
    const {
      data: { payment_methods },
    } = response;
    yield put(UserActions.fetchPaymentInfoSuccess(payment_methods));
  } catch (err) {
    const error = err as any;
    const message = error?.response?.data?.error?.message;
    yield put(
      UserActions.fetchUserFail(
        message?.[i18n.getLang()] || 'Error occurred fetching payment info',
      ),
    );
  }
}

export function* watchFetchPaymentInfo() {
  yield takeLatest(UserActions.FETCH_PAYMENT_INFO, handleFetchPaymentInfo);
}
